var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageWithTextV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_24860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59124 10.5457H10.1367C10.7389 10.5457 11.2275 10.0569 11.2275 9.45481C11.2275 8.85256 10.7389 8.36377 10.1367 8.36377H3.59124C2.98899 8.36377 2.5004 8.85256 2.5004 9.45481C2.5004 10.0569 2.98899 10.5457 3.59124 10.5457Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59124 6.18188H10.1367C10.7389 6.18188 11.2275 5.69309 11.2275 5.09084C11.2275 4.48879 10.7389 4 10.1367 4H3.59124C2.98899 4 2.5004 4.48879 2.5004 5.09084C2.5004 5.69309 2.98899 6.18188 3.59124 6.18188Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59124 14.9092H10.1367C10.7389 14.9092 11.2275 14.4206 11.2275 13.8184C11.2275 13.2161 10.7389 12.7275 10.1367 12.7275H3.59124C2.98899 12.7275 2.5004 13.2161 2.5004 13.8184C2.5004 14.4206 2.98899 14.9092 3.59124 14.9092Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59091 19.2727H25.4092C26.0112 19.2727 26.5 18.7839 26.5 18.1817C26.5 17.5796 26.0112 17.0908 25.4092 17.0908H3.59091C2.98866 17.0908 2.50006 17.5796 2.50006 18.1817C2.50006 18.7839 2.98866 19.2727 3.59091 19.2727Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59091 23.6365H25.4092C26.0112 23.6365 26.5 23.1477 26.5 22.5456C26.5 21.9434 26.0112 21.4546 25.4092 21.4546H3.59091C2.98866 21.4546 2.50006 21.9434 2.50006 22.5456C2.50006 23.1477 2.98866 23.6365 3.59091 23.6365Z",
    fill: "#86BB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0455 4H24.8636C25.7659 4 26.5 4.73409 26.5 5.63636V13.2727C26.5 14.1749 25.7659 14.909 24.8636 14.909H15.0455C14.1432 14.909 13.4091 14.1749 13.4091 13.2727V5.63636C13.4091 4.73409 14.1432 4 15.0455 4ZM15.591 6.18189V10.5836L17.141 9.18834C17.5797 8.79563 18.2517 8.8186 18.6596 9.24727L20.4324 11.104L21.2909 10.2968C21.7273 9.88648 22.4145 9.90505 22.828 10.3393L24.3181 11.9026V6.18189H15.591Z",
    fill: "#86BB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_24860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 26.5 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageWithTextV2);
export default __webpack_public_path__ + "static/media/ImageWithTextV2.89115b10acf5c157c75c3872035fb45e.svg";
export { ForwardRef as ReactComponent };